// extracted by mini-css-extract-plugin
export default {"prices":"njQxpb","priceTo":"n4gMEk","priceFrom":"SenqAc","price":"luBSqF"};